/* eslint-disable no-undef */

import React, { Component } from "react";
import {
  withGoogleMap,
  GoogleMap,
  Circle,
  Polygon,
  Rectangle,
  Marker,
} from "react-google-maps";
import DrawingManager from "react-google-maps/lib/drawing/DrawingManager";
import { RadioButton, RadioButtonGroup } from "material-ui";
import {
  getMapVectorOptions,
  getMutableCircleOptions,
  getCityAvgSpeed,
} from "../../../utils/utility";
import { FullRow } from "../../framework/Grid";
import Geosuggest from "react-geosuggest";
import Tooltip from "rc-tooltip";
import Slider from "rc-slider";
import "rc-tooltip/assets/bootstrap_white.css";
import "rc-slider/assets/index.css";

import { _, isEmpty } from "lodash";
import "./map.css";

const INITIAL_CENTER = { lat: 42.87, lng: -97.38 };
const radioButtonStyle = {
  labeStyle: {
    color: "#EDEDED",
    fontSize: "0.9em",
  },
  inputStyle: {
    fill: "#EDEDED",
    height: "16px",
    width: "16px",
    marginLeft: "4px",
    marginRight: "8px",
    marginTop: "2px",
  },
  firstRadioStyle: {
    width: "35%",
    float: "left",
  },
  secondRadioStyle: {
    width: "60%",
    float: "left",
  },
};

//reference https://developers.google.com/maps/documentation/geocoding/intro#Types
const addressTypes = [
  "street_address",
  "premise",
  "subpremise",
  "airport",
  "park",
  "neighborhood",
  "floor",
  "point_of_interest",
  "establishment",
  "parking",
  "post_box",
  "room",
  "street_number",
  "bus_station",
  "train_station",
  "transit_station",
];

class MapSelector extends Component {
  overlayComplete = e => {
    const overlay = e.overlay;
    switch (e.type) {
      case "circle":
        const radius = e.overlay.getRadius();
        const center = e.overlay.getCenter();
        const c = {
          center: center,
          radius: radius,
          visible: true,
        };
        this.setState({
          circle: c,
          readyApply: true,
        });
        break;
      case "rectangle":
        var bounds = e.overlay.getBounds();
        this.setState({
          rect: {
            bounds: bounds,
            visible: true,
          },
          readyApply: true,
        });
        break;
      //case "polygon":
      default:
        this.setState({
          polygon: {
            path: e.overlay.getPath(),
            visible: true,
          },
          readyApply: true,
        });
        break;
    }

    this.setState({
      defaultDrawingMode: null,
      onDrawing: false,
    });
    this.calTotalAudience();
    this.applySelect(true);
    google.maps.event.clearInstanceListeners(overlay);
    overlay.setMap(null);
  };

  constructor(props) {
    super(props);

    this.state = {
      showDrawingTool: false,
      defaultDrawingMode: null,
      circles: [],
      openReset: false,
      circle: {
        center: null,
        radius: 0,
        visible: false,
      },
      rect: {
        bounds: null,
        visiable: false,
      },
      polygon: {
        path: [],
        visiable: false,
      },
      zoom: 4,
      bounds: null,
      center: INITIAL_CENTER,
      audienceCount: {
        total: 0,
        email: 0,
        display: 0,
        social: 0,
      },
    };
  }
  onStartDrawing(type) {
    this.setState({
      circle: {
        center: null,
        radius: 0,
        visible: false,
      },
      rect: {
        bounds: null,
        visiable: false,
      },
      polygon: {
        path: [],
        visiable: false,
      },
      zoom: this._map.getZoom(),
      center: this._map.getCenter(),
      onDrawing: false,
      readyApply: false,
    });
    switch (type) {
      case "circle":
        this.setState({
          defaultDrawingMode: google.maps.drawing.OverlayType.CIRCLE,
        });
        //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.CIRCLE)
        break;
      case "rectangle":
        this.setState({
          defaultDrawingMode: google.maps.drawing.OverlayType.RECTANGLE,
        });
        //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.RECTANGLE)
        break;
      //case "polygon":
      default:
        this.setState({
          defaultDrawingMode: google.maps.drawing.OverlayType.POLYGON,
        });
        //this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON)
        break;
    }
  }

  handleMapMounted(map) {
    this._map = map;
  }

  handleCenterChanged() {
    const nextCenter = this._map.getCenter();
    if (nextCenter.equals(new google.maps.LatLng(INITIAL_CENTER))) {
      return;
    }

    this.setState({
      center: nextCenter,
    });
  }

  handleZoomChanged() {
    this.setState({
      zoom: this._map.getZoom(),
      center: this._map.getCenter(),
    });
  }

  calTotalAudience() {
    const result = { total: 0, email: 0, display: 0, social: 0 };
    this.setState({
      audienceCount: result,
    });
  }

  handleBoundsChanged() {
    this.setState({
      bounds: this._map.getBounds(),
      center: this._map.getCenter(),
    });
  }
  isAddress(suggest) {
    return (
      suggest &&
      suggest.gmaps &&
      suggest.gmaps.types &&
      addressTypes.findIndex(function(o) {
        return suggest.gmaps.types.indexOf(o) > -1;
      }) > -1
    );
  }

  handleSuggestSelect(suggest) {
    if (suggest) {
      const isAddress = this.isAddress(suggest);
      this.setState({
        center: suggest.location,
        updateComponent: true,
        search_suggest: suggest,
        radiusVal: null,
        driveRadiusVal: null,
        driveTimeVal: null,
      });
      if (isAddress) {
        this.setState({
          marker: {
            position: {
              lat: suggest.location.lat,
              lng: suggest.location.lng,
            },
            key: "address",
          },
        });
        if (this.state.zoom < 15) this.setState({ zoom: 15 });
      } else {
        if (this.state.zoom < 13) this.setState({ zoom: 13 });
      }
    }
  }

  handleOpenResetDialog(e, status) {
    e.preventDefault();
    this.setState({
      openReset: status,
      resetAnchorEl: e.currentTarget,
    });
  }

  handleStartOverDialog(e, status) {
    if (e) {
      e.preventDefault();
      this.setState({
        openStartOver: status,
        startOverAnchorEl: e.currentTarget,
      });
    } else {
      this.setState({
        openStartOver: status,
      });
    }
  }

  handleAddressStartOverDialog(e, status) {
    if (e) {
      e.preventDefault();
      this.setState({
        openAddressStartOver: status,
        openStartOver: false,
        addressOpenOverAnchorEl: e.currentTarget,
      });
    } else {
      this.setState({
        openStartOver: false,
        openAddressStartOver: status,
      });
    }
  }

  clearAllDrawing() {
    this.setState({
      circle: {
        center: null,
        radius: 0,
        visible: false,
      },
      rect: {
        bounds: null,
        visiable: false,
      },
      polygon: {
        path: [],
        visiable: false,
      },
      readyApply: false,
      onDrawing: false,
      search_suggest: null,
      radiusVal: null,
      driveRadiusVal: null,
      driveTimeVal: null,
      audienceCount: { total: 0, email: 0, display: 0, social: 0 },
      marker: {},
    });
    this.props.onApplyChanges({});
  }

  updateCircleInfo() {
    this.setState({
      circle: {
        center: this._circle.getCenter(),
        radius: this._circle.getRadius(),
        visible: true,
      },
      readyApply: true,
    });
    this.calTotalAudience();
    this.applySelect(true);
  }

  updateRectInfo() {
    let bounds = null;
    try {
      bounds = this._rectangle.getBounds();
    } catch (ex) {}

    if (bounds !== null) {
      this.setState({
        rect: {
          bounds: this._rectangle.getBounds(),
          visible: true,
        },
        readyApply: true,
      });
      this.calTotalAudience();
      this.applySelect(true);
    }
  }

  preparePolygonInfo() {
    google.maps.event.addListener(this._polygon, "set_at", () => {
      this._getPolygonNewPaths(this._polygon);
    });
    google.maps.event.addListener(this._polygon, "insert_at", () => {
      this._getPolygonNewPaths(this._polygon);
    });
    google.maps.event.addListener(this._polygon, "remove_at", () => {
      this._getPolygonNewPaths(this._polygon);
    });
  }
  updatePolygonInfo(e) {
    this.setState({ onDraging: true });
    this.calTotalAudience();
    this.applySelect(true);
    this.setState({ onDraging: false });
  }

  handleStartOver() {
    this.setState({
      showDrawingTool: false,
      defaultDrawingMode: null,
      onDrawing: false,
      readyApply: false,
      width: this.state.width,
      circles: [],
      openReset: false,
      circle: {
        center: null,
        radius: 0,
        visible: false,
      },
      rect: {
        bounds: null,
        visiable: false,
      },
      polygon: {
        path: [],
        visiable: false,
      },
      zoom: 4,
      bounds: null,
      marker: {},
      search_suggest: null,
      center: INITIAL_CENTER,
      audienceCount: {
        total: 0,
        email: 0,
        display: 0,
        social: 0,
      },
    });
    this._geoSuggest.clear();
    this.props.onApplyChanges({});
  }
  applySelect(updateCountOnly) {
    if (this.isAddress(this.state.search_suggest)) {
      let address = null;
      this.props.onUpdateAudienceCount(null);

      switch (this.state.drawAddrType) {
        case "radius":
          address = {
            type: "address_radius",
            addressLabel: this.state.search_suggest.label,
            center: this.state.search_suggest.location,
            radius: this.state.radiusVal,
            zoom: this.state.zoom,
            audienceCount: this.state.audienceCount,
          };
          break;
        //case "drive":
        default:
          address = {
            type: "address_drive",
            zoom: this.state.zoom,
            addressLabel: this.state.search_suggest.label,
            center: this.state.search_suggest.location,
            driveTime: this.state.driveTimeVal,
            driveRadius: this.state.driveRadiusVal,
            audienceCount: this.state.audienceCount,
          };
          break;
      }
      if (address !== null) {
        if (updateCountOnly) this.props.onUpdateAudienceCount(address);
        else this.props.onApplyChanges(address);
      }
    } else {
      this.props.onUpdateAudienceCount(null);
      if (this.state.circle.visible === true) {
        const circle = {
          center: this.state.circle.center,
          radius: this.state.circle.radius,
          type: "circle",
          zoom: this.state.zoom,
          audienceCount: this.state.audienceCount,
        };
        if (updateCountOnly) this.props.onUpdateAudienceCount(circle);
        else this.props.onApplyChanges(circle);
      }
      if (this.state.rect.visible === true) {
        const ne = this.state.rect.bounds.getNorthEast();
        const sw = this.state.rect.bounds.getSouthWest();
        const rectBound = new google.maps.LatLngBounds(sw, ne);
        const rectangle = {
          bounds: this.state.rect.bounds,
          center: rectBound.getCenter(),
          type: "rectangle",
          zoom: this.state.zoom,
          audienceCount: this.state.audienceCount,
        };
        if (updateCountOnly) this.props.onUpdateAudienceCount(rectangle);
        else this.props.onApplyChanges(rectangle);
      }
      if (this.state.polygon.visible === true) {
        const polygonBounds = new google.maps.LatLngBounds();
        const polygonPath = this._polygon.getPath();
        polygonPath.forEach(function(element, index) {
          polygonBounds.extend(element);
        });
        const polygon = {
          path: polygonPath,
          encode_path: google.maps.geometry.encoding.encodePath(polygonPath),
          center: polygonBounds.getCenter(), //this._map.getCenter(),
          type: "polygon",
          zoom: this.state.zoom,
          audienceCount: this.state.audienceCount,
        };
        if (updateCountOnly) this.props.onUpdateAudienceCount(polygon);
        else this.props.onApplyChanges(polygon);
      }
    }
    if (!updateCountOnly) {
      this.setState({ readyApply: false, onDraging: false });
      this.props.onClose();
    }
  }

  handleRadioChange(e, value) {
    e.preventDefault();
    if (this.state.drawAddrType !== value) {
      this.setState({
        drawAddrType: value,
        radiusVal: 0,
        driveRadiusVal: 0,
        driveTimeVal: 0,
        audienceCount: { total: 0, email: 0, display: 0, social: 0 },
      });
      this.props.onApplyChanges({});
    }
  }

  _onRadiusAfterChange(value) {
    if (this.state.readyApply === false) {
      if (value > 0) {
        setTimeout(
          function() {
            this._map.fitBounds(this._addressCircle.getBounds());
          }.bind(this),
          200,
        );
        setTimeout(
          function() {
            this.applySelect(true);
            this.setState({
              readyApply: true,
            });
          }.bind(this),
          200,
        );
      } else {
        setTimeout(
          function() {
            this.setState({ zoom: 15, readyApply: true });
          }.bind(this),
          200,
        );
        this.applySelect(true);
      }
      this.calTotalAudience();
    }
  }

  _handleRadiusChange(value) {
    this.setState({
      radiusVal: value,
      readyApply: false,
    });
  }

  _handleDriveTimeChange(value) {
    this.setState({
      driveTimeVal: value,
      readyApply: false,
    });
  }

  _onDriveTimeAfterChange(value) {
    if (this.state.readyApply === false) {
      this.calTotalAudience();
      const radius =
        ((getCityAvgSpeed(this.state.search_suggest.label) * value) / 1000) *
        0.6;
      this.setState({
        driveTimeVal: value,
        driveRadiusVal: radius,
        radiusVal: radius,
        readyApply: false,
      });
      if (value > 0) {
        setTimeout(
          function() {
            this._map.fitBounds(this._driveCircle.getBounds());
          }.bind(this),
          200,
        );
        setTimeout(
          function() {
            this.applySelect(true);
            this.setState({
              readyApply: true,
            });
          }.bind(this),
          300,
        );
      } else {
        setTimeout(
          function() {
            this.setState({ zoom: 15, readyApply: true });
          }.bind(this),
          200,
        );
        this.applySelect(true);
      }
    }
  }

  _getPolygonNewPaths = polygon => {
    if (!this.state.readyApply)
      this.setState({
        readyApply: true,
      });

    let polygonPaths = [];
    polygon.getArray().forEach((path, index) => {
      const line = {
        lat: path.lat(),
        lng: path.lng(),
      };
      polygonPaths.push(line);
    });

    this.calTotalAudience();
    this.applySelect(true);
  };

  _handleClose(e) {
    e.preventDefault();
    this.setState({ readyApply: false, onDraging: false });

    setTimeout(
      function() {
        this.props.onClose();
      }.bind(this),
      50,
    );
  }

  _initMap(plottedValue) {
    this.setState({
      circle: {
        center: null,
        radius: 0,
        visible: false,
      },
      rect: {
        bounds: null,
        visiable: false,
      },
      polygon: {
        path: [],
        visiable: false,
      },
      readyApply: false,
      onDrawing: false,
      search_suggest: null,
      radiusVal: null,
      driveRadiusVal: null,
      driveTimeVal: null,
      audienceCount: { total: 0, email: 0, display: 0, social: 0 },
      marker: {},
    });

    switch (plottedValue.type) {
      case "address_radius":
      case "address_drive":
        this.setState({
          center: plottedValue.center,
          zoom: plottedValue.zoom,
          updateComponent: true,
          search_suggest: {
            gmaps: { types: ["street_address"] },
            label: plottedValue.addressLabel,
            location: plottedValue.center,
          },
          radiusVal: plottedValue.radius,
          driveTimeVal: plottedValue.driveTime,
          driveRadiusVal: plottedValue.driveRadius,
          drawAddrType:
            plottedValue.type === "address_radius" ? "radius" : "drive",
        });
        this.setState({
          marker: {
            position: {
              lat: plottedValue.center.lat,
              lng: plottedValue.center.lng,
            },
            key: "address",
          },
        });
        break;
      case "rectangle":
        this.setState({
          center: plottedValue.center,
          zoom: plottedValue.zoom,
          rect: {
            bounds: plottedValue.bounds,
            visiable: true,
          },
        });
        break;
      case "circle":
      default:
        this.setState({
          center: plottedValue.center,
          zoom: plottedValue.zoom,
          circle: {
            center: plottedValue.center,
            radius: plottedValue.radius,
            visiable: true,
          },
        });
        break;
      case "polygon":
        this.setState({
          center: plottedValue.center,
          zoom: plottedValue.zoom,
          polygon: {
            path:
              typeof plottedValue.path === "string"
                ? google.maps.geometry.encoding.decodePath(plottedValue.path)
                : plottedValue.path,
            visiable: true,
          },
        });

        break;
    }
  }

  componentDidMount() {
    const width = document.getElementById("CreateSegment")
      ? document.getElementById("CreateSegment").clientWidth
      : null;
    this.setState({ width: width ? width : 1280 });
    const { plottedValue } = this.props;
    if (!isEmpty(plottedValue)) {
      this._initMap(plottedValue);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.onDraging === true || this.state.onDraging === true)
      return false;

    return true;
  }

  render() {
    const btnStartOver = (
      <Tooltip
        visible={this.state.openStartOver}
        overlayStyle={{ zIndex: 9999 }}
        animation="zoom"
        onVisibleChange={visible => this.handleStartOverDialog(null, visible)}
        trigger="click"
        overlay={[
          <FullRow
            key="so-text-row"
            className="text-default no-padding-bottom no-margin-bottom"
          >
            Are you sure you want to start over?
            <br />
            Any selections you have made will not be saved
            <br />
            <br />
          </FullRow>,
          <FullRow key="so-btn-row" className="no-padding-bottom">
            <a
              className="btn btn-link btn-sm text-teal-400 mr-20"
              onClick={e => {
                this.handleStartOverDialog(e, false);
              }}
            >
              Close
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a
              className="btn btn-aa-default btn-round btn-sm bg-grey text-white ml-20"
              onClick={e => {
                e.preventDefault();
                this.handleStartOver();
                this.handleStartOverDialog(e, false);
              }}
            >
              Yes, reset
            </a>
          </FullRow>,
        ]}
      >
        <a
          className="btn btn-link no-padding pt-10 ml-10 text-capitalize text-size-small text-white"
          onClick={e => {
            this.handleStartOverDialog(e, true);
          }}
        >
          Start over
        </a>
      </Tooltip>
    );

    const btnAddressStartOver = (
      <Tooltip
        visible={this.state.openAddressStartOver}
        overlayStyle={{ zIndex: 9999 }}
        animation="zoom"
        onVisibleChange={visible =>
          this.handleAddressStartOverDialog(null, visible)
        }
        trigger="click"
        overlay={[
          <FullRow
            key="so-text-row"
            className="text-default no-padding-bottom no-margin-bottom"
          >
            Are you sure you want to start over?
            <br />
            Any selections you have made will not be saved
            <br />
            <br />
          </FullRow>,
          <FullRow key="so-btn-row" className="no-padding-bottom">
            <a
              className="btn btn-link btn-sm text-teal-400 mr-20"
              onClick={e => {
                this.handleAddressStartOverDialog(e, false);
              }}
            >
              Close
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a
              className="btn btn-aa-default btn-round btn-sm bg-grey text-white ml-20"
              onClick={e => {
                e.preventDefault();
                this.handleStartOver();
                this.handleAddressStartOverDialog(e, false);
              }}
            >
              Yes, reset
            </a>
          </FullRow>,
        ]}
      >
        <a
          className="btn btn-link no-padding pt-10 ml-10 text-capitalize text-size-small text-white mt-10"
          onClick={e => {
            this.handleStartOverDialog(e, true);
          }}
        >
          Start over
        </a>
      </Tooltip>
    );

    const circle_options = getMapVectorOptions();
    const { onClose } = this.props;
    let drawingBtnClass = "btn btn-icon pt-10 no-padding mr-20 ";
    let removeDrawingBtnClass =
      "btn btn-icon pt-10 no-padding mr-20 text-white ";
    const applyBtnClass =
      this.state.readyApply === true
        ? "btn btn-rounded btn-xs text-uppercase bg-teal-400"
        : "btn btn-rounded disabled btn-xs text-uppercase bg-teal-400 ";
    if (this.state.onDrawing === true || this.state.readyApply === true)
      drawingBtnClass += " disabled";
    else removeDrawingBtnClass += " disabled";
    const SegmentGoogleMap = withGoogleMap(props => (
      <GoogleMap
        defaultCenter={this.state.center}
        defaultOptions={{
          streetViewControl: false,
          mapTypeControl: false,
        }}
        ref={props.onMapLoad}
        defaultZoom={4}
        onZoomChanged={props.onZoomChanged}
        zoom={props.zoom}
        center={props.center}
      >
        <DrawingManager
          ref={elm => (this.drawingManager = elm)}
          defaultDrawingMode={null}
          defaultOptions={{
            drawingControl: false,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: [
                google.maps.drawing.OverlayType.CIRCLE,
                google.maps.drawing.OverlayType.POLYGON,
                google.maps.drawing.OverlayType.RECTANGLE,
              ],
            },
            circleOptions: circle_options,
            rectangleOptions: circle_options,
            polymgonOptions: circle_options,
          }}
          drawingMode={this.state.defaultDrawingMode}
          onOverlayComplete={this.overlayComplete.bind(this)}
        />
        <Circle
          center={this.state.circle.center}
          ref={circle => (this._circle = circle)}
          radius={this.state.circle.radius}
          visiable={this.state.circle.visible}
          editable={true}
          draggable={false}
          options={circle_options}
          onCenterChanged={this.updateCircleInfo.bind(this)}
          onRadiusChanged={this.updateCircleInfo.bind(this)}
        />
        <Circle
          center={
            this.state.search_suggest
              ? this.state.search_suggest.location
              : null
          }
          ref={circle => (this._addressCircle = circle)}
          radius={this.state.radiusVal * 1609.34}
          visible={this.state.drawAddrType === "radius"}
          editable={false}
          draggable={false}
          options={getMutableCircleOptions()}
        />
        <Circle
          center={
            this.state.search_suggest
              ? this.state.search_suggest.location
              : null
          }
          ref={circle => (this._driveCircle = circle)}
          radius={this.state.driveRadiusVal * 1609.34}
          visible={this.state.drawAddrType === "drive"}
          editable={false}
          draggable={false}
          options={getMutableCircleOptions()}
        />
        <Rectangle
          bounds={this.state.rect.bounds}
          visiable={this.state.rect.visible}
          ref={rectangle => (this._rectangle = rectangle)}
          editable={true}
          draggable={true}
          options={circle_options}
          onDragEnd={() => {
            this.setState({ onDraging: false });
          }}
          onDragStart={() => {
            this.setState({ onDraging: true });
          }}
          //onMouseDown={()=>{this.setState({onDraging: true})}}
          //onMouseUp={()=>{this.setState({onDraging: false})}}
          onBoundsChanged={this.updateRectInfo.bind(this)}
        />
        <Polygon
          path={this.state.polygon.path}
          visiable={this.state.polygon.visible}
          ref={polygon => (this._polygon = polygon)}
          //onMouseDown={this.preparePolygonInfo.bind(this)}
          editable={true}
          draggable={true}
          options={circle_options}
          onMouseUp={this.updatePolygonInfo.bind(this)}
        />
        <Marker {...this.state.marker} />
      </GoogleMap>
    ));

    const showAddressTool = this.isAddress(this.state.search_suggest);
    return (
      <div>
        <SegmentGoogleMap
          containerElement={
            <div style={{ height: `100%`, minHeight: "480px" }} />
          }
          mapElement={<div style={{ height: `100%`, minHeight: "480px" }} />}
          zoom={this.state.zoom}
          center={this.state.center}
          onMapLoad={this.handleMapMounted.bind(this)}
          onBoundsChanged={this.handleBoundsChanged.bind(this)}
          onZoomChanged={this.handleZoomChanged.bind(this)}
          bounds={this.state.bounds}
        />
        <div
          className="pl-20 pr-20 pb-10 pt-15"
          style={{
            color: "white",
            width: "600px",
            height: "55px",
            position: "absolute",
            left: this.state.width ? (this.state.width - 680) / 2 : 200,
            top: 5,
            backgroundColor: "rgba(0,0,0, 0.6)",
            display: this.state.zoom < 5 && !showAddressTool ? "block" : "none",
          }}
        >
          <span className="pull-left mr-10 pt-5">ZOOM-IN OR </span>
          <span className="pull-left text-grey" style={{ width: "420px" }}>
            <Geosuggest
              ref={el => (this._geoSuggest = el)}
              onSuggestSelect={this.handleSuggestSelect.bind(this)}
              suggestsClassName={"find-address-suggest"}
              suggestItemClassName={"find-address-suggest-item"}
              suggestItemActiveClassName={"find-address-suggest-active-item"}
              placeholder={"Find a Place"}
              types={["geocode"]}
              country={"us"}
            />
          </span>
          <span
            className="pull-left"
            style={{ marginLeft: "-20px", marginTop: "3px", color: "grey" }}
          >
            <i className="icon-search4" />
          </span>
          <div className="pull-right">
            <a onClick={this._handleClose.bind(this)}>
              <i className="icon-cancel-circle2 text-teal-400" />
            </a>
          </div>
        </div>
        <div
          className="pl-20 pr-20 pb-10"
          style={{
            color: "white",
            width: "600px",
            paddingTop: "5px",
            height: "70px",
            position: "absolute",
            left: this.state.width ? (this.state.width - 680) / 2 : 200,
            top: 5,
            backgroundColor: "rgba(0,0,0, 0.6)",
            display: this.state.zoom < 5 || showAddressTool ? "none" : "block",
          }}
        >
          <span>Select a drawing tool to plot a radius</span>
          <div className="pull-right">
            <a onClick={this._handleClose.bind(this)}>
              <i className="icon-cancel-circle2 text-teal-400" />
            </a>
          </div>
          <br />
          <a
            className={drawingBtnClass}
            onClick={e => {
              e.preventDefault();
              this.onStartDrawing("circle");
            }}
          >
            <i className="icon-circle text-white" />
          </a>
          <a
            className={drawingBtnClass}
            onClick={e => {
              e.preventDefault();
              this.onStartDrawing("rectangle");
            }}
          >
            <i className=" icon-checkbox-unchecked text-white" />
          </a>
          <a
            className={drawingBtnClass}
            onClick={e => {
              e.preventDefault();
              this.onStartDrawing("polygon");
            }}
          >
            <i className=" icon-stats-growth2 text-white" />
          </a>
          <a
            className={removeDrawingBtnClass}
            style={{ textTransform: "capitalize" }}
            onClick={e => {
              e.preventDefault();
              this.clearAllDrawing();
            }}
          >
            X Delete Radius
          </a>
          <a
            style={{
              padding: "3px 10px",
              marginTop: "5px",
              marginLeft: "90px",
            }}
            className={applyBtnClass}
            onClick={this.applySelect.bind(this, false)}
          >
            Apply Map Selection{" "}
          </a>
          {btnStartOver}
        </div>
        <div
          className="pl-20 pr-20 pb-10 pt-10"
          style={{
            color: "white",
            width: "680px",
            paddingTop: "5px",
            height: "140px",
            position: "absolute",
            left: this.state.width ? (this.state.width - 680) / 2 : 200,
            top: 5,
            backgroundColor: "rgba(0,0,0, 0.6)",
            display: showAddressTool ? "block" : "none",
          }}
        >
          <div className="text-grey pull-left" style={{ width: "380px" }}>
            <input
              className="no-border pl-5 pr-5 pt-5 pb-5 "
              type="text"
              readOnly
              style={{ width: "100%" }}
              value={
                this.state.search_suggest ? this.state.search_suggest.label : ""
              }
            />
          </div>
          <div
            className="text-grey ml-20"
            style={{ width: "220px", display: "inline-block" }}
          >
            <RadioButtonGroup
              name="radio_group_address"
              onChange={this.handleRadioChange.bind(this)}
              valueSelected={this.state.drawAddrType}
            >
              <RadioButton
                value="radius"
                label="RADIUS"
                labelStyle={radioButtonStyle.labeStyle}
                iconStyle={radioButtonStyle.inputStyle}
                style={radioButtonStyle.firstRadioStyle}
              />
              <RadioButton
                value="drive"
                label="DRIVE TIME"
                labelStyle={radioButtonStyle.labeStyle}
                iconStyle={radioButtonStyle.inputStyle}
                style={radioButtonStyle.secondRadioStyle}
              />
            </RadioButtonGroup>
          </div>
          <div className="pull-right" style={{ marginTop: "-10px" }}>
            <a onClick={onClose}>
              <i className="icon-cancel-circle2 text-teal-400 mt-10" />
            </a>
          </div>
          <div
            style={{
              display: this.state.drawAddrType === "radius" ? "block" : "none",
            }}
          >
            <Slider
              className="slider-radius"
              min={0}
              max={100}
              included={true}
              step={1}
              onChange={this._handleRadiusChange.bind(this)}
              value={this.state.radiusVal}
              onAfterChange={this._onRadiusAfterChange.bind(this)}
              marks={{
                5: "5",
                10: "10",
                25: "25",
                50: "50",
                75: "75",
                100: "100",
              }}
            />
            <input
              type="text"
              readOnly
              style={{ width: "100px" }}
              value={this.state.radiusVal ? this.state.radiusVal : ""}
              className="no-border pl-5 pr-5 pt-5 pb-5 text-teal-400"
            />{" "}
            &nbsp; Miles
          </div>
          <div
            style={{
              display: this.state.drawAddrType === "drive" ? "block" : "none",
            }}
          >
            <Slider
              className="slider-radius"
              min={0}
              max={4}
              included={true}
              step={0.5}
              onChange={this._handleDriveTimeChange.bind(this)}
              onAfterChange={this._onDriveTimeAfterChange.bind(this)}
              value={this.state.driveTimeVal}
              marks={{
                0.5: "0.5",
                1: "1",
                1.5: "1.5",
                2: "2",
                2.5: "2.5",
                3: "3",
                3.5: "3.5",
                4: "4",
              }}
            />
            <input
              type="text"
              readOnly
              style={{ width: "100px" }}
              value={this.state.driveTimeVal ? this.state.driveTimeVal : ""}
              className="no-border pl-5 pr-5 pt-5 pb-5 text-teal-400"
            />{" "}
            &nbsp; HR(S)
          </div>
          <div>
            <a
              style={{ padding: "3px 10px", marginTop: "20px" }}
              className={applyBtnClass}
              onClick={e => {
                e.preventDefault();
                this.applySelect(false);
              }}
            >
              Apply
            </a>
            &nbsp;&nbsp;&nbsp;{btnAddressStartOver}
          </div>
        </div>
      </div>
    );
  }
}

export default MapSelector;



// WEBPACK FOOTER //
// ./src/components/Segment/Map/index.js